import get from 'lodash/get'
import { ANALYTICS_EVENTS } from '../utils'
import { formatDate } from '../../../van-shared/utils/utils'
import { calculateProgressPercentage } from '../../../subapps/reports/common/utils'

export const getReportTrackingHandler = ({ events }) => {
  const {
    STOCK_REPORT_STARTED,
    STOCK_REPORT_SAVED,
    STOCK_REPORT_SUBMITTED,
    STOCK_REPORT_EDITED,
    STOCK_FIELD_FILLED,
    BATCH_EXPIRY_REPORTED
  } = ANALYTICS_EVENTS

  return {
    started: (data) => {
      const reportId = get(data, 'report._id')
      const periodDisplayed = get(data, 'period.display', 'not specified')
      events.track(STOCK_REPORT_STARTED, {
        report_id: reportId,
        reporting_month: periodDisplayed
      })
    },

    saved: (data) => {
      const report = get(data, 'report')
      const reportId = get(data, 'report._id')
      const progressPercentage = Math.round(calculateProgressPercentage(report) * 100)
      const newdata = {
        report_id: reportId,
        progress_percent: progressPercentage,
        progress_percent_label: `${progressPercentage}%`
      }
      events.track(STOCK_REPORT_SAVED, newdata)
    },

    submitted: (data) => {
      const reportId = get(data, 'report._id')
      const totalReport = get(data, 'report.progress.total')
      events.track(STOCK_REPORT_SUBMITTED, {
        report_id: reportId,
        total_products_reported: totalReport
      })
    },

    edited: (data) => {
      const reportId = get(data, 'report._id')
      events.track(STOCK_REPORT_EDITED, {
        report_id: reportId
      })
    },

    // Input events
    fieldFilled: (data = {}) => {
      const { name, productId, label, amount, expiryDate, reset } = data

      if (name === STOCK_FIELD_FILLED) {
        events.track(STOCK_FIELD_FILLED, {
          product_id: productId,
          field_name: label,
          value: amount
        })
      }

      if (name === BATCH_EXPIRY_REPORTED) {
        const newdata = {
          product_id: productId,
          expiry_date: expiryDate ? formatDate(expiryDate, 'monthYearLong') : null,
          quantity: amount
        }

        if (reset) {
          newdata.reset = reset
        }

        events.track(BATCH_EXPIRY_REPORTED, newdata)
      }
    }
  }
}
